"use client";

import { listExamSessions } from "@/lib/server-actions/examSessionActions";
import type { ExamSession } from "@/lib/types";

/**
 * 공용 ExamSessionProvider 에 주입하는 JCG 회차 조회.
 *
 * 서버 액션의 `{ success, sessions }` 응답을 공용 계약(`Promise<ExamSession[]>`)으로 좁힌다.
 * 공용 패키지가 이 서버 액션을 직접 부르면 JBGP 빌드에서도 JCG Firestore 를 읽게 되므로
 * 앱 쪽에서 주입한다.
 */
export async function listJcgExamSessions(): Promise<ExamSession[]> {
  const result = await listExamSessions();
  return result.success ? result.sessions : [];
}
